import { component } from 'picoapp';
import gsap from 'gsap';
const hoverintent = require('hoverintent');

class MainNav extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {

    this.items = this.querySelectorAll('menu-item[class*="level-1"');
    hoverintent(
      this,
      () => { },
      () => {
        this.items.forEach(i => {
          if (i.hasSubmenu) {
            i.off()
          }
        })
      }).options({
        interval: 0,
        timeout: 100,
      })
  }
  dispatchToggle(identifier) {
    const filterItems = Array.from(this.items).filter(element => element.dataset.identifier != identifier);
    filterItems.forEach(i => {
      if (i.hasSubmenu) {
        i.off()
      }
    })
  }
};

class MenuItem extends HTMLElement {
  constructor() {
    super();
  }

  get identifier() {
    return this.getAttribute('data-identifier')
  }

  get isActive() {
    return this.getAttribute('aria-expanded') == 'true' ? true : false
  }

  get hasSubmenu() {
    return this.getAttribute('aria-haspopup') == 'true' ? true : false
  }

  connectedCallback() {
    if (this.classList.contains('level-1') && this.closest('main-nav')) {
      this.init()
    }
  }

  init() {
    const trigger = this.querySelector('.Nav__link');
    trigger.addEventListener('click', e => {
      if (!this.isActive && this.hasSubmenu) {
        e.preventDefault()
      }
      this.toggle()
      this.closest('main-nav').dispatchToggle(this.identifier)
    })
    hoverintent(
      trigger,
      () => {
        if (!this.isActive) {
          if (this.getAttribute("aria-haspopup") == "true") {
            this.on()
          }
          this.closest('main-nav').dispatchToggle(this.identifier)
        }
      },
      () => {
      },
    ).options({
      timeout: 100,
    })
  }

  toggle() {
    this.isActive ? this.off() : this.on()
  }

  on() {
    this.setAttribute('aria-expanded', true)
    this.querySelector('menu-item-submenu')?.setAttribute('aria-expanded', true)
  }

  off() {
    this.setAttribute('aria-expanded', false)
    this.querySelector('menu-item-submenu')?.setAttribute('aria-expanded', false)
  }
};

class Submenu extends HTMLElement {
  constructor() {
    super();

  }
  connectedCallback() {
    if (this.closest('main-nav')) {
      this.tl = gsap.timeline({
        paused: true
      })
      this.tl.set(this, { display: 'block', immediateRender: false });
      this.tl.to(this, { opacity: 1, height: 'auto', duration: 0.1, ease: 'power.out' })
    }
  }

  static get observedAttributes() {
    return ['aria-expanded'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    //Only attribute recorded is "aria-expanded" so the "newValue" is either true or false
    newValue == 'true' ? this.tl?.play() : this.tl?.reverse()
  }

  on() {
    this.setAttribute('aria-expanded', true)
  }

  off() {
    this.setAttribute('aria-expanded', false)
  }
};

export default component((node, ctx) => {
  if (!customElements.get('main-nav')) {
    customElements.define('main-nav', MainNav);
  }
  if (!customElements.get('menu-item')) {
    customElements.define('menu-item', MenuItem);
  }
  if (!customElements.get('menu-item-submenu')) {
    customElements.define('menu-item-submenu', Submenu);
  }
});
